import { FontWeights, MediaDesktop } from '@lichtblick/theme';
import styled from 'styled-components';
const responsiveFontSizes = {
    desktop: {
        M: '1.25rem',
        L: '1.75rem'
    },
    mobile: {
        M: '1.125rem',
        L: '1.5625rem'
    }
};
export const Wrapper = styled.span`
  font-size: ${({ $size = 'M' })=>responsiveFontSizes.mobile[$size]};
  font-weight: ${FontWeights.Bold};
  line-height: 140%;

  ${MediaDesktop} {
    font-size: ${({ $size = 'M' })=>responsiveFontSizes.desktop[$size]};
  }
`;

//# sourceMappingURL=AccentText.styles.js.map